import { render } from "./ProjectView.vue?vue&type=template&id=7876c13e&scoped=true&ts=true"
import script from "./ProjectView.vue?vue&type=script&lang=ts"
export * from "./ProjectView.vue?vue&type=script&lang=ts"

import "./ProjectView.vue?vue&type=style&index=0&id=7876c13e&lang=scss&scoped=true"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7876c13e"]])

export default __exports__